import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-oauth-redirect',
  standalone: true,
  imports: [],
  templateUrl: './oauth-redirect.component.html',
  styleUrl: './oauth-redirect.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OauthRedirectComponent {}
